// @flow
import { authenticatedFetch } from '../../api/request';

const deleteCoach = async (orgId: number, coachId: number) => {
    const path = `/v5/orgs/${orgId}/assistantCoaches/${coachId}`;
    const requestOptions = {
        method: 'DELETE'
    };
    return await authenticatedFetch(path, requestOptions);
};

export default deleteCoach;
